import { Component, inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { StorageService } from '../shared/services/storage.service';
import {
  MatSnackBar,
} from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private _snackBar = inject(MatSnackBar);
  environment = environment

  hide = true;

  authForm: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });

  submitted = false;
  isLoggedIn = false;
  isLoginFailed = false;
  loading = false;
  errorMessage = '';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router
  ) {}

  ngOnInit() {
    this.authForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.authForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;
    this.isLoginFailed = false;
    this.errorMessage = '';

    if (this.authForm.invalid) {
      return;
    }

    this.loading = true;

    this.authService
      .login(this.authForm.value.username, this.authForm.value.password)
      .subscribe({
        next: (result) => {
          this.loading = false;
          this.storageService.saveUser(result);

          this.isLoginFailed = false;
          this.isLoggedIn = true;
          this.router.navigateByUrl('/').then(() => {
            window.location.reload();
          });
        },
        error: (error) => {
          this.loading = false;
          this.isLoginFailed = true;
          this.errorMessage = error?.error?.message ?? 'Credenciais inválidas';
          this.openSnackBar(this.errorMessage);
          this.isLoggedIn = false;
        },
      });
  }

  openSnackBar(message: string) {
    this._snackBar.open(message || 'Credenciais inválidas', 'Fechar', { duration: 3500 });
  }
}
